import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import cn from "classnames";
import Loadable from "@loadable/component";
import adjust1 from "../../assets/images/salary/projects/adjust.png";

const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const Arrow = () => {
  return (
    <div
      className="flex-grow-1 position-relative"
      style={{
        borderTop: "1px solid #212529",
        transform: "translateY(50%)",
      }}
    >
      <i
        className="bx bx-chevron-down position-absolute end-0"
        style={{
          transform: "translateX(33%) translateY(calc(-50% - 1px)) rotate(270deg)",
        }}
      ></i>
    </div>
  );
};

const Projects = () => {
  const [initialized, setInitialized] = useState(false);
  const [startPosition, setStartPosition] = useState(1);

  const options = {
    loop: true,
    nav: true,
    dots: false,
    autoplay: false,
    autoplayHoverPause: true,
    mouseDrag: false,
    touchDrag: false,
    margin: 30,
    items: 1,
    navText: ["<i class='flaticon-left-1'></i>", "<i class='flaticon-right-1'></i>"],
  };
  const tabs = [
    {
      id: 1,
      title: "复杂薪资核算",
      image: adjust1,
      render: tab => {
        return (
          <div className="overview-box">
            <div className="overview-image">
              <div className="image">
                <img src={tab.image} alt={tab.title} className="rounded" />
              </div>
            </div>
            <div className="overview-content">
              <div className="content">
                <p>
                  <strong className="text-theme">个性化薪资项目：</strong>支持各种政策补贴，党费缴纳，职业年金，缺勤扣款等工资项目
                </p>
                <p>
                  <strong className="text-theme">多种工资项：</strong>支持岗位工资、薪级工资、基础性绩效、奖励性绩效、津补贴、社保、公积金
                </p>
                <p>
                  <strong className="text-theme">全面核算方式：</strong>计件核算、计时核算、混合核算
                </p>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      id: 2,
      title: "多样化发薪解决方案",
      program: ["每月X号发薪", "每X周发一次薪", "日薪制", "时薪制"],
      employees: [
        ["临时工A", "计件发薪"],
        ["临时工B", "混合发薪"],
        ["临时工C", "定额发薪"],
      ],
      render: tab => {
        return (
          <div className="overview-box">
            <div className="col-7 row justify-content-around">
              <div
                className="col-5 py-3 px-1 rounded"
                style={{
                  border: "1px solid #cecece",
                }}
              >
                <div className="row m-0">
                  {tab.program.map(pm => {
                    return (
                      <div className="col-6 px-1 mb-2">
                        <div className="h-100 text-white text-center rounded py-5 px-2" style={{ background: "#4571c9" }}>
                          {pm}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <p className="mt-2 text-center">支持设置不同分公司，不同发薪周期</p>
              </div>
              <div
                className="col-5 py-3 px-1 rounded d-flex flex-column"
                style={{
                  border: "1px solid #cecece",
                }}
              >
                <div className="flex-grow-1">
                  {tab.employees.map(([empType, salType]) => {
                    return (
                      <div className="row m-0 mx-3 mb-3" key={empType}>
                        <div className="text-white text-center rounded py-3 px-2" style={{ background: "#4571c9" }}>
                          {empType}
                        </div>
                        <Arrow />
                        <div className="text-white text-center rounded py-3 px-2" style={{ background: "#4571c9" }}>
                          {salType}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <p className="mt-2 text-center">系统根据公式自动计算汇总</p>
              </div>
            </div>
            <div className="col-5">
              <div className="content">
                <p><strong className="text-theme">自定义发薪周期：</strong>支持自定义发薪周期，支持月薪、周薪、年薪、季度、十天一发等</p>
                <p><strong className="text-theme">按项目结算发薪：</strong>按项目实施进度汇总发薪</p>
                <p><strong className="text-theme">集团发薪：</strong>不同分公司，不同发薪周期，全球多币种无缝换算</p>
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  const onInit = () => setInitialized(true);

  const onCarouselChange = event => {
    if (!initialized) return;
    const {
      item: { index },
      property: { value },
    } = event;
    if (typeof value === "number") {
      setStartPosition((index - 1) % tabs.length);
    }
  };

  return (
    <div className="content position-relative">
      <div className="courses-details-desc mx-5 px-3 position-relative" style={{ marginBottom: -43, zIndex: 3 }}>
        <ul className="nav nav-tabs justify-content-around" id="myTab" role="tablist">
          {tabs.map((tab, idx) => (
            <li
              key={tab.title}
              className={cn({
                current: startPosition === idx,
              })}
              onClick={() => setStartPosition(idx)}
            >
              {tab.title}
            </li>
          ))}
        </ul>
      </div>
      <OwlCarousel
        {...options}
        stageClass="pt-5 mt-3"
        className="testimonials-slides owl-carousel owl-theme rounded"
        style={{ zIndex: 1 }}
        startPosition={startPosition}
        onInitialize={onInit}
        onChange={onCarouselChange}
      >
        {tabs.map(tab => (
          <Card className="shadow">
            <CardBody>{tab.render(tab)}</CardBody>
          </Card>
        ))}
      </OwlCarousel>
    </div>
  );
};

export default Projects;
